"use strict";

// eslint-disable-next-line no-empty-function
module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/function/noop.js
// module id = ../../../node_modules/es5-ext/function/noop.js
// module chunks = 1